<script setup>
import { Link } from  "@inertiajs/vue3";

defineProps({
    data: {
        type: [Object, null],
        required: false,
        default: null,
    },
});
</script>

<template>
    <div v-if="data?.meta?.links?.length > 3">
        <div class="py-2">
            <div class="w-full flex flex-wrap justify-center">
                <template v-for="(link, linkKey) in data.meta.links" :key="linkKey">
                    <div v-if="link.url === null" class="mx-[2px] px-4 py-3 text-sm leading-4 text-gray-400 border rounded" v-html="link.label" />
                    <Link v-else
                          class="mx-[2px] px-4 py-3 text-sm leading-4 border rounded hover:bg-gray-50 focus:border-blue-900 focus:text-blue-900"
                          :class="{ '!bg-blue-700 hover:!bg-blue-900 focus:!bg-blue-900 !text-white': link.active }"
                          :href="link.url" v-html="link.label" />
                </template>
            </div>
        </div>
    </div>
</template>
